import { Component } from '@angular/core'

@Component({
  selector: 'ld-not-found',
  template: require('./not-found.component.html'),
  styles: [require('./not-found.component.css')]
})
export class NotFoundComponent {}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/not-found/not-found.component.ts